define.alias("shared/components/shared/guidelines", "media/components/shared/guidelines");